module.exports = __webpack_public_path__ + "static/media/rupee.6bedbd53.svg";